export default [
    {
        wrapperClass: "mb-15",
        name: "Normal",
        imageSrc: "icon-layout-normal.svg",
        key: "normal",
        pageContentClass: "normal",

        headingsMainSmallSize: 38,
        headingsMainSmallLineHeight: 1.2,
        headingsMainSize: 48,
        headingsMainLineHeight: 1.2,
        headingsMainLargeSize: 54,
        headingsMainLargeLineHeight: 1.2,

        subheadingSmallSize: 23,
        subheadingSmallLineHeight: 1.3,
        subheadingNormalSize: 38,
        subheadingNormalLineHeight: 1.3,
        subheadingLargeSize: 48,
        subheadingLargeLineHeight: 1.2,

        heading3SmallSize: 18,
        heading3SmallLineHeight: 1.3,
        heading3NormalSize: 23,
        heading3NormalLineHeight: 1.3,
        heading3LargeSize: 38,
        heading3LargeLineHeight: 1.3,

        heading4SmallSize: 14,
        heading4SmallLineHeight: 1.4,
        heading4NormalSize: 18,
        heading4NormalLineHeight: 1.4,
        heading4LargeSize: 23,
        heading4LargeLineHeight: 1.3,

        mainTextTinySize: 10,
        mainTextTinyLineHeight: 1.55,

        mainTextVerySmallSize: 13,
        mainTextVerySmallLineHeight: 1.55,

        mainTextSmallSize: 15,
        mainTextSmallLineHeight: 1.55,

        mainTextNormalSize: 17,
        mainTextNormalLineHeight: 1.55,

        mainTextLargeSize: 22,
        mainTextLargeLineHeight: 1.4,

        mainTextVeryLargeSize: 26,
        mainTextVeryLargeLineHeight: 1.3,

        mainTextHugeSize: 32,
        mainTextHugeLineHeight: 1.2,

        sectionSmallPadding: 40,
        sectionNormalPadding: 80,
        sectionLargePadding: 120,
        sectionVeryLargePadding: 160,
    },
    // {
    //     wrapperClass: "mb-15",
    //     name: "Normal loud",
    //     imageSrc: "icon-layout-normal_l.svg",
    //     key: "normal-loud",
    //     pageContentClass: "normal-loud",

    //     headingsMainSmallSize: 72,
    //     headingsMainSmallLineHeight: 1.2,
    //     headingsMainSize: 76,
    //     headingsMainLineHeight: 1.2,
    //     headingsMainLargeSize: 82,
    //     headingsMainLargeLineHeight: 1.2,

    //     subheadingSmallSize: 54,
    //     subheadingSmallLineHeight: 1.3,
    //     subheadingNormalSize: 58,
    //     subheadingNormalLineHeight: 1.3,
    //     subheadingLargeSize: 62,
    //     subheadingLargeLineHeight: 1.2,

    //     heading3SmallSize: 36,
    //     heading3SmallLineHeight: 1.3,
    //     heading3NormalSize: 40,
    //     heading3NormalLineHeight: 1.3,
    //     heading3LargeSize: 44,
    //     heading3LargeLineHeight: 1.3,

    //     heading4SmallSize: 26,
    //     heading4SmallLineHeight: 1.4,
    //     heading4NormalSize: 30,
    //     heading4NormalLineHeight: 1.4,
    //     heading4LargeSize: 34,
    //     heading4LargeLineHeight: 1.3,

    //     mainTextTinySize: 8,
    //     mainTextTinyLineHeight: 1.55,

    //     mainTextVerySmallSize: 11,
    //     mainTextVerySmallLineHeight: 1.55,

    //     mainTextSmallSize: 14,
    //     mainTextSmallLineHeight: 1.55,

    //     mainTextNormalSize: 17,
    //     mainTextNormalLineHeight: 1.55,

    //     mainTextLargeSize: 24,
    //     mainTextLargeLineHeight: 1.4,

    //     mainTextVeryLargeSize: 48,
    //     mainTextVeryLargeLineHeight: 1.3,

    //     mainTextHugeSize: 70,
    //     mainTextHugeLineHeight: 1.2,

    //     sectionSmallPadding: 30,
    //     sectionNormalPadding: 80,
    //     sectionLargePadding: 160,
    //     sectionVeryLargePadding: 210,
    // },
    {
        wrapperClass: "mb-15",
        name: "Comfort",
        imageSrc: "icon-layout-loose.svg",
        key: "loose",
        pageContentClass: "loose",

        headingsMainSmallSize: 38,
        headingsMainSmallLineHeight: 1.25,
        headingsMainSize: 48,
        headingsMainLineHeight: 1.25,
        headingsMainLargeSize: 54,
        headingsMainLargeLineHeight: 1.25,

        subheadingSmallSize: 23,
        subheadingSmallLineHeight: 1.35,
        subheadingNormalSize: 38,
        subheadingNormalLineHeight: 1.35,
        subheadingLargeSize: 48,
        subheadingLargeLineHeight: 1.3,

        heading3SmallSize: 18,
        heading3SmallLineHeight: 1.4,
        heading3NormalSize: 23,
        heading3NormalLineHeight: 1.4,
        heading3LargeSize: 30,
        heading3LargeLineHeight: 1.4,

        heading4SmallSize: 14,
        heading4SmallLineHeight: 1.5,
        heading4NormalSize: 18,
        heading4NormalLineHeight: 1.55,
        heading4LargeSize: 23,
        heading4LargeLineHeight: 1.55,

        mainTextTinySize: 10,
        mainTextTinyLineHeight: 1.7,

        mainTextVerySmallSize: 13,
        mainTextVerySmallLineHeight: 1.7,

        mainTextSmallSize: 15,
        mainTextSmallLineHeight: 1.65,

        mainTextNormalSize: 17,
        mainTextNormalLineHeight: 1.65,

        mainTextLargeSize: 22,
        mainTextLargeLineHeight: 1.6,

        mainTextVeryLargeSize: 26,
        mainTextVeryLargeLineHeight: 1.35,

        mainTextHugeSize: 32,
        mainTextHugeLineHeight: 1.25,

        sectionSmallPadding: 70,
        sectionNormalPadding: 120,
        sectionLargePadding: 180,
        sectionVeryLargePadding: 220,
    },
    // {
    //     wrapperClass: "mb-15",
    //     name: "Comfort loud",
    //     imageSrc: "icon-layout-loose_l.svg",
    //     key: "loose-loud",
    //     pageContentClass: "loose-loud",

    //     headingsMainSmallSize: 72,
    //     headingsMainSmallLineHeight: 1.2,
    //     headingsMainSize: 76,
    //     headingsMainLineHeight: 1.2,
    //     headingsMainLargeSize: 82,
    //     headingsMainLargeLineHeight: 1.2,

    //     subheadingSmallSize: 54,
    //     subheadingSmallLineHeight: 1.3,
    //     subheadingNormalSize: 58,
    //     subheadingNormalLineHeight: 1.3,
    //     subheadingLargeSize: 62,
    //     subheadingLargeLineHeight: 1.25,

    //     heading3SmallSize: 36,
    //     heading3SmallLineHeight: 1.35,
    //     heading3NormalSize: 40,
    //     heading3NormalLineHeight: 1.35,
    //     heading3LargeSize: 44,
    //     heading3LargeLineHeight: 1.35,

    //     heading4SmallSize: 26,
    //     heading4SmallLineHeight: 1.5,
    //     heading4NormalSize: 30,
    //     heading4NormalLineHeight: 1.5,
    //     heading4LargeSize: 34,
    //     heading4LargeLineHeight: 1.4,

    //     mainTextTinySize: 8,
    //     mainTextTinyLineHeight: 1.65,

    //     mainTextVerySmallSize: 11,
    //     mainTextVerySmallLineHeight: 1.65,

    //     mainTextSmallSize: 14,
    //     mainTextSmallLineHeight: 1.6,

    //     mainTextNormalSize: 17,
    //     mainTextNormalLineHeight: 1.6,

    //     mainTextLargeSize: 24,
    //     mainTextLargeLineHeight: 1.55,

    //     mainTextVeryLargeSize: 48,
    //     mainTextVeryLargeLineHeight: 1.35,

    //     mainTextHugeSize: 70,
    //     mainTextHugeLineHeight: 1.2,

    //     sectionSmallPadding: 40,
    //     sectionNormalPadding: 100,
    //     sectionLargePadding: 180,
    //     sectionVeryLargePadding: 230,
    // },
    {
        wrapperClass: "mb-15",
        name: "Condensed",
        imageSrc: "icon-layout-condensed.svg",
        key: "condensed",
        pageContentClass: "condensed",

        headingsMainSmallSize: 38,
        headingsMainSmallLineHeight: 1.2,
        headingsMainSize: 48,
        headingsMainLineHeight: 1.15,
        headingsMainLargeSize: 54,
        headingsMainLargeLineHeight: 1.1,

        subheadingSmallSize: 23,
        subheadingSmallLineHeight: 1.2,
        subheadingNormalSize: 38,
        subheadingNormalLineHeight: 1.2,
        subheadingLargeSize: 48,
        subheadingLargeLineHeight: 1.2,

        heading3SmallSize: 18,
        heading3SmallLineHeight: 1.3,
        heading3NormalSize: 23,
        heading3NormalLineHeight: 1.3,
        heading3LargeSize: 30,
        heading3LargeLineHeight: 1.3,

        heading4SmallSize: 14,
        heading4SmallLineHeight: 1.3,
        heading4NormalSize: 18,
        heading4NormalLineHeight: 1.3,
        heading4LargeSize: 23,
        heading4LargeLineHeight: 1.3,

        mainTextTinySize: 10,
        mainTextTinyLineHeight: 1.45,

        mainTextVerySmallSize: 13,
        mainTextVerySmallLineHeight: 1.45,

        mainTextSmallSize: 15,
        mainTextSmallLineHeight: 1.45,

        mainTextNormalSize: 17,
        mainTextNormalLineHeight: 1.4,

        mainTextLargeSize: 22,
        mainTextLargeLineHeight: 1.3,

        mainTextVeryLargeSize: 26,
        mainTextVeryLargeLineHeight: 1.2,

        mainTextHugeSize: 32,
        mainTextHugeLineHeight: 1.2,

        sectionSmallPadding: 20,
        sectionNormalPadding: 60,
        sectionLargePadding: 100,
        sectionVeryLargePadding: 130,
    },
    // {
    //     wrapperClass: "mb-15",
    //     name: "Condensed loud",
    //     imageSrc: "icon-layout-condensed_l.svg",
    //     key: "condensed-loud",
    //     pageContentClass: "condensed-loud",

    //     headingsMainSmallSize: 72,
    //     headingsMainSmallLineHeight: 1.1,
    //     headingsMainSize: 76,
    //     headingsMainLineHeight: 1.1,
    //     headingsMainLargeSize: 82,
    //     headingsMainLargeLineHeight: 1.1,

    //     subheadingSmallSize: 54,
    //     subheadingSmallLineHeight: 1.2,
    //     subheadingNormalSize: 58,
    //     subheadingNormalLineHeight: 1.2,
    //     subheadingLargeSize: 62,
    //     subheadingLargeLineHeight: 1.15,

    //     heading3SmallSize: 36,
    //     heading3SmallLineHeight: 1.3,
    //     heading3NormalSize: 40,
    //     heading3NormalLineHeight: 1.3,
    //     heading3LargeSize: 44,
    //     heading3LargeLineHeight: 1.3,

    //     heading4SmallSize: 26,
    //     heading4SmallLineHeight: 1.3,
    //     heading4NormalSize: 30,
    //     heading4NormalLineHeight: 1.3,
    //     heading4LargeSize: 34,
    //     heading4LargeLineHeight: 1.3,

    //     mainTextTinySize: 8,
    //     mainTextTinyLineHeight: 1.45,

    //     mainTextVerySmallSize: 11,
    //     mainTextVerySmallLineHeight: 1.45,

    //     mainTextSmallSize: 14,
    //     mainTextSmallLineHeight: 1.45,

    //     mainTextNormalSize: 17,
    //     mainTextNormalLineHeight: 1.4,

    //     mainTextLargeSize: 24,
    //     mainTextLargeLineHeight: 1.3,

    //     mainTextVeryLargeSize: 48,
    //     mainTextVeryLargeLineHeight: 1.2,

    //     mainTextHugeSize: 70,
    //     mainTextHugeLineHeight: 1.2,

    //     sectionSmallPadding: 20,
    //     sectionNormalPadding: 60,
    //     sectionLargePadding: 120,
    //     sectionVeryLargePadding: 180,
    // },
    {
        wrapperClass: "mb-15",
        name: "Mega",
        imageSrc: "icon-layout-mega.svg",
        key: "mega",
        pageContentClass: "mega",

        headingsMainSmallSize: 50,
        headingsMainSmallLineHeight: 1.25,
        headingsMainSize: 58,
        headingsMainLineHeight: 1.25,
        headingsMainLargeSize: 72,
        headingsMainLargeLineHeight: 1.25,

        subheadingSmallSize: 30,
        subheadingSmallLineHeight: 1.35,
        subheadingNormalSize: 48,
        subheadingNormalLineHeight: 1.35,
        subheadingLargeSize: 58,
        subheadingLargeLineHeight: 1.3,

        heading3SmallSize: 26,
        heading3SmallLineHeight: 1.4,
        heading3NormalSize: 30,
        heading3NormalLineHeight: 1.4,
        heading3LargeSize: 40,
        heading3LargeLineHeight: 1.4,

        heading4SmallSize: 20,
        heading4SmallLineHeight: 1.55,
        heading4NormalSize: 25,
        heading4NormalLineHeight: 1.55,
        heading4LargeSize: 30,
        heading4LargeLineHeight: 1.45,

        mainTextTinySize: 11,
        mainTextTinyLineHeight: 1.7,

        mainTextVerySmallSize: 14,
        mainTextVerySmallLineHeight: 1.7,

        mainTextSmallSize: 17,
        mainTextSmallLineHeight: 1.65,

        mainTextNormalSize: 20,
        mainTextNormalLineHeight: 1.65,

        mainTextLargeSize: 26,
        mainTextLargeLineHeight: 1.6,

        mainTextVeryLargeSize: 30,
        mainTextVeryLargeLineHeight: 1.35,

        mainTextHugeSize: 40,
        mainTextHugeLineHeight: 1.25,

        sectionSmallPadding: 80,
        sectionNormalPadding: 130,
        sectionLargePadding: 190,
        sectionVeryLargePadding: 240,
    },
    {
        wrapperClass: "mb-15",
        name: "Micro",
        imageSrc: "icon-layout-micro.svg",
        key: "micro",
        pageContentClass: "micro",

        headingsMainSmallSize: 30,
        headingsMainSmallLineHeight: 1.2,
        headingsMainSize: 38,
        headingsMainLineHeight: 1.15,
        headingsMainLargeSize: 44,
        headingsMainLargeLineHeight: 1.1,

        subheadingSmallSize: 20,
        subheadingSmallLineHeight: 1.2,
        subheadingNormalSize: 30,
        subheadingNormalLineHeight: 1.2,
        subheadingLargeSize: 38,
        subheadingLargeLineHeight: 1.2,

        heading3SmallSize: 15,
        heading3SmallLineHeight: 1.3,
        heading3NormalSize: 20,
        heading3NormalLineHeight: 1.3,
        heading3LargeSize: 27,
        heading3LargeLineHeight: 1.3,

        heading4SmallSize: 16,
        heading4SmallLineHeight: 1.3,
        heading4NormalSize: 18,
        heading4NormalLineHeight: 1.3,
        heading4LargeSize: 20,
        heading4LargeLineHeight: 1.3,

        mainTextTinySize: 8,
        mainTextTinyLineHeight: 1.45,

        mainTextVerySmallSize: 10,
        mainTextVerySmallLineHeight: 1.45,

        mainTextSmallSize: 12,
        mainTextSmallLineHeight: 1.45,

        mainTextNormalSize: 15,
        mainTextNormalLineHeight: 1.4,

        mainTextLargeSize: 19,
        mainTextLargeLineHeight: 1.3,

        mainTextVeryLargeSize: 22,
        mainTextVeryLargeLineHeight: 1.2,

        mainTextHugeSize: 29,
        mainTextHugeLineHeight: 1.2,

        sectionSmallPadding: 16,
        sectionNormalPadding: 50,
        sectionLargePadding: 86,
        sectionVeryLargePadding: 110,
    }, 
]